var React = require('react');

function Upload (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#151427","fillRule":"nonzero"},[React.createElement("path",{"d":"M38.374 23.645a.892.892 0 0 0-.896.896v8.149a4.02 4.02 0 0 1-4.015 4.015H13.807a4.02 4.02 0 0 1-4.015-4.015v-8.282a.892.892 0 0 0-.896-.896.892.892 0 0 0-.896.896v8.282a5.813 5.813 0 0 0 5.807 5.807h19.656a5.813 5.813 0 0 0 5.807-5.807v-8.15a.896.896 0 0 0-.896-.895z","key":0}),React.createElement("path",{"d":"M18.571 16.743l4.168-4.167v18.176c0 .498.398.896.896.896a.892.892 0 0 0 .896-.896V12.576l4.167 4.167a.902.902 0 0 0 .63.266.863.863 0 0 0 .631-.266.893.893 0 0 0 0-1.267l-5.694-5.694a.907.907 0 0 0-.63-.265.868.868 0 0 0-.63.265l-5.694 5.694a.893.893 0 1 0 1.26 1.267z","key":1})]));
}

Upload.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48"};

module.exports = Upload;

Upload.default = Upload;
